import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ReportTemplatePicker({ chantier, onChanged }) {
  const [templates, setTemplates] = useState([]);
  const [selected, setSelected] = useState(chantier?.report_template_id || "");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/report-templates").then((r) => setTemplates(r.data)).catch(() => setTemplates([]));
  }, []);
  useEffect(() => { setSelected(chantier?.report_template_id || ""); }, [chantier?.report_template_id]);

  const pick = async (tid) => {
    setSelected(tid);
    setSaving(true);
    try {
      await api.patch(`/chantiers/${chantier.id}`, { report_template_id: tid || null });
      toast.success(tid ? "Modèle appliqué" : "Modèle retiré");
      onChanged?.();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setSaving(false); }
  };

  if (templates.length === 0) return null;

  return (
    <div className="rounded-2xl bg-white/[0.03] border border-white/10 p-4">
      <div className="text-[11px] uppercase tracking-widest text-white/50 mb-2">Modèle graphique du rapport</div>
      <div className="grid grid-cols-2 gap-2">
        <button
          onClick={() => pick("")}
          disabled={saving}
          className={`text-left rounded-xl p-3 border transition-colors ${!selected ? "bg-white/10 border-white/30" : "bg-white/[0.02] border-white/5 hover:border-white/20"}`}
          data-testid="rt-none"
        >
          <div className="text-sm font-medium">Défaut BKPRO</div>
          <div className="text-[10px] text-white/40">Aucun modèle appliqué</div>
        </button>
        {templates.map((t) => (
          <button
            key={t.id}
            onClick={() => pick(t.id)}
            disabled={saving}
            className={`text-left rounded-xl p-3 border transition-colors ${selected === t.id ? "border-white/30" : "border-white/5 hover:border-white/20"}`}
            style={{ background: selected === t.id ? t.primary_color + "22" : "rgba(255,255,255,0.02)" }}
            data-testid={`rt-pick-${t.id}`}
          >
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 rounded-full shrink-0" style={{ background: t.primary_color, border: `1px solid ${t.accent_color}` }} />
              <span className="text-sm font-medium truncate">{t.name}</span>
            </div>
            <div className="text-[10px] text-white/40 truncate mt-0.5">{t.intervention_type || "—"}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
